<template>
  <main class="remaining-paid-leave">
    <header class="report-header">
      <div class="report-heading">
        <h1>Справка оставащ платен отпуск на служителите.</h1>
        <p class="search-hint">
          Натиснете <kbd>Ctrl</kbd>+<kbd>F</kbd> или <kbd>⌘</kbd>+<kbd>F</kbd>, за да търсите в страницата.
        </p>
      </div>
      <button class="excel-button" :disabled="loading || !employees.length" @click="exportExcel">
        <img src="@/assets/img/excel.svg" alt="Excel" />
        ЕКСПОРТ В EXCEL
      </button>
    </header>

    <div v-if="loading" class="report-message">Зареждане...</div>
    <div v-else-if="!employees.length" class="report-message">Няма служители за показване.</div>
    <div v-else class="report-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Служебен номер</th>
            <th>Име, презиме, фамилия</th>
            <th>Длъжност</th>
            <th>Остатък (дни)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="employee in employees" :key="employee._id">
            <td>
              <a :href="employeeVacationsUrl(employee._id)">{{ employee.number }}</a>
            </td>
            <td>
              <a :href="employeeVacationsUrl(employee._id)">{{ employee.name }}</a>
            </td>
            <td>
              <a :href="employeeVacationsUrl(employee._id)">{{ employee.position }}</a>
            </td>
            <td>
              <a :href="employeeVacationsUrl(employee._id)">{{ employee.remaining }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </main>
</template>

<script>
import config from '../../../config-public.json';

export default {
  data() {
    return {
      employees: [],
      loading: true,
    };
  },
  methods: {
    employeeVacationsUrl(id) {
      return `${config.loginPath}/users/${id}/vacations`;
    },
    getEmployees() {
      this.loading = true;
      this.$apiService
        .get('/users/remaining-paid-leave')
        .then((res) => {
          this.employees = res.data;
        })
        .catch(() => {
          this.$snotify.error('Справката не може да бъде заредена. Моля опитайте отново.');
        })
        .then(() => {
          this.loading = false;
        });
    },
    exportExcel() {
      window.open(`${process.env.VUE_APP_BASE_URI}/users/remaining-paid-leave/export`, '_blank');
    },
  },
  mounted() {
    this.getEmployees();
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';

.remaining-paid-leave {
  min-height: 100%;
  padding: 70px 45px 30px;
}

.report-header {
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-bottom: 18px;

  h1 {
    font-size: $px14;
    font-weight: 700;
  }
}

.report-heading {
  min-width: 0;
}

.search-hint {
  color: #64788c;
  font-size: $px12;
  margin-top: 7px;

  kbd {
    background: #f3f7fb;
    border: 1px solid #d4dfe9;
    border-bottom-width: 2px;
    border-radius: 3px;
    color: #40566c;
    font-family: inherit;
    font-size: inherit;
    padding: 1px 4px;
  }
}

.excel-button {
  align-items: center;
  background: #e8fff3;
  border: 1px solid #80d29e;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: $px12;
  font-weight: 500;
  gap: 7px;
  height: 32px;
  padding: 0 9px;
  white-space: nowrap;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  &:not(:disabled):hover {
    background: #daffec;
  }
}

.report-table-wrapper {
  overflow-x: auto;
  @include scrollbar(5px, $mainColor);
}

table {
  border-collapse: separate;
  border-spacing: 0 10px;
  min-width: 680px;
  width: 100%;
}

th {
  color: #a7b7c8;
  font-size: $px12;
  font-weight: 700;
  padding: 0 12px 2px;
  text-align: left;
  text-transform: uppercase;
}

td {
  background: #f3f7fb;
  font-size: $px13;
  padding: 0;

  a {
    color: inherit;
    display: block;
    padding: 14px 12px;
    text-decoration: none;
  }

  &:first-child {
    border-radius: 6px 0 0 6px;
    width: 15%;
  }

  &:nth-child(2) {
    width: 34%;
  }

  &:nth-child(3) {
    width: 36%;
  }

  &:last-child {
    border-radius: 0 6px 6px 0;
    text-align: right;
    width: 15%;
  }
}

tbody tr:hover td {
  background: #eaf2f9;
}

.report-message {
  color: #64788c;
  font-size: $px13;
  padding: 35px 0;
  text-align: center;
}

@media screen and (max-width: $s) {
  .remaining-paid-leave {
    padding: 25px 15px;
  }

  .report-header {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
